<template>
	<div class="mt-2 rounded-md border border-orange-400 bg-orange-50 p-2">
		<p class="text-sm text-gray-700">Promo applied</p>
		<p class="text-base text-orange-400">
			<span class="font-medium uppercase">
				{{ promotion.code }}
			</span>
			<template v-if="promotion.description">
				- {{ promotion.description }}
			</template>
		</p>
	</div>
</template>

<script setup lang="ts">
import type { CheckoutPromotion } from '@/types/order-checkout'

interface Props {
	promotion: CheckoutPromotion
}

defineProps<Props>()
</script>
